import { FaHeart, FaShareAlt } from "react-icons/fa";
import ReactionBar from "../ui/ReactionBar";
import ShareModal from "../modals/ShareModal";
import useMediaActions from "../../hooks/useMediaActions";
import { useAuth } from "../../features/auth/AuthContext";
import { percent } from "../../lib/text";
import { useState } from "react";

/**
 * The blurred-backdrop detail header. MovieTitle and SerieTitle were two
 * near-identical copies of this; the differences are now props.
 */
const MediaHero = ({
  media,
  target,
  showReactions = true,
  shareType,
  children,
}) => {
  const { isAuthenticated } = useAuth();
  const [sharing, setSharing] = useState(false);
  const actions = useMediaActions(target, media.id, media.user_action);

  const rating = percent(
    (media.likes_count / (media.dislikes_count + media.likes_count)) * 100
  );

  return (
    <div className="h-[400px] w-full text-white md:h-screen">
      <img
        className="absolute left-[5%] z-10 hidden rounded-md shadow-sm sm:top-[6rem] sm:flex sm:h-[200px] sm:w-[160px] md:top-[22%] md:h-[380px] md:w-[250px]"
        src={media.cover}
        alt={media.name}
      />

      <div className="h-full w-full">
        <div className="absolute z-10 h-[400px] w-full bg-gradient-to-l from-black via-black to-transparent opacity-70 md:h-screen" />
        <img
          className="h-[98%] w-full object-cover blur-md"
          src={media.cover}
          alt={media.name}
        />

        <div className="absolute top-[9%] z-20 w-full p-4 sm:top-[18%] md:p-8">
          <h1 className="text-right text-4xl font-bold leading-[54px] md:text-5xl">
            {media.name}
          </h1>

          {rating !== null && (
            <p className="mt-6 flex flex-row items-center text-right text-xl font-bold leading-4">
              <FaHeart size={25} className="mb-1 ml-2" />
              {rating}%
            </p>
          )}

          {media.price && (
            <p className="mt-7 text-right text-xl font-bold leading-6 text-brand md:text-2xl">
              قیمت:<span> {media.price}</span>
              <span> تومان</span>
            </p>
          )}

          <div className="my-4">
            <p
              className="mt-6 w-full text-justify text-base font-semibold leading-6 text-gray-200 md:max-w-[62%] lg:max-w-[50%] xl:max-w-[35%]"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {media.description}
            </p>
            {children}
          </div>

          {isAuthenticated && (
            <div className="mt-0 flex items-center gap-4 md:mt-8">
              <ReactionBar actions={actions} showReactions={showReactions} />
              {shareType && (
                <button
                  type="button"
                  onClick={() => setSharing(true)}
                  aria-label="اشتراک‌گذاری"
                >
                  <FaShareAlt className="cursor-pointer text-2xl text-gray-300 transition hover:text-white md:text-3xl" />
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {shareType && (
        <ShareModal
          open={sharing}
          onClose={() => setSharing(false)}
          id={media.id}
          type={shareType}
        />
      )}
    </div>
  );
};

export default MediaHero;
